import { render, staticRenderFns } from "./new_issue_modal.vue?vue&type=template&id=5d0a6a3a"
import script from "./new_issue_modal.vue?vue&type=script&lang=ts"
export * from "./new_issue_modal.vue?vue&type=script&lang=ts"
import style0 from "./new_issue_modal.vue?vue&type=style&index=0&id=5d0a6a3a&lang=scss"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-bcca2229bc/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/.yarn/cache/vue-hot-reload-api-npm-2.3.4-549ae26337-9befc0b3d6.zip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0a6a3a')) {
      api.createRecord('5d0a6a3a', component.options)
    } else {
      api.reload('5d0a6a3a', component.options)
    }
    module.hot.accept("./new_issue_modal.vue?vue&type=template&id=5d0a6a3a", function () {
      api.rerender('5d0a6a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/issues/new_issue_modal.vue"
export default component.exports